export default __webpack_public_path__ + "static/BCParks_Primary_Reversed_Vertical-9873b7442479cf33ebc73121675114fa.svg";